/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#3a559f" d="M0 0v32h17.042V19.639h-4.166v-5.046h4.166v-4.238a5.58 5.58 0 015.581-5.58h4.355v4.538h-3.116c-.979 0-1.773.794-1.773 1.773v3.508H26.9l-.665 5.046h-4.146v12.361h9.912v-32h-32z"/>'
  }
})
